enum ItemStatus {
  LIKED = "LIKED",
  DISLIKED = "DISLIKED",
}

export { ItemStatus };
